import React from 'react';
function Card({name, email, id}){
        return(
            <div className="bg-light-green dib br3 pa3 ma2 grow">
                <img alt = "robot" src= {'https://robohash.org/' + id} width="200px" height = "200px"/>
                <div>
                    <h2>{name}</h2>
                    <p>{email}</p>
                    
                </div>
                

            </div>

        );

}
export default  Card;